import { SearchResults } from "./SearchResults";
import { SearchResultsDisplayComponentProps } from "../../search-results-container/types";
import { NoResults } from "../../no-results/NoResults";
import { KalturaESearchEntryResponse } from "kaltura-typescript-client/api/types/KalturaESearchEntryResponse";

export const SearchResultsData = ({
    isSearch,
    isTextSearch,
    fetchModuleData,
    onEntryShowMore,
    page,
    onPageChange,
    isWideLayout,
    pageSize,
}: SearchResultsDisplayComponentProps<KalturaESearchEntryResponse>) => {
    const { data } = fetchModuleData();

    if (!data?.totalCount) {
        return <NoResults screenMode={isSearch ? "nomatches" : "nopublic"} />;
    }

    return (
        <SearchResults
            entryResults={data}
            isTextSearch={isTextSearch}
            page={page}
            onPageChange={onPageChange}
            pageSize={pageSize}
            onEntryShowMore={onEntryShowMore}
            isWideLayout={isWideLayout}
        />
    );
};
